/**
 * APPLICATION BOOTSTRAP
 *
 * This is the entry point of the entire application.
 * It mounts the root Svelte component (App.svelte) into the DOM.
 *
 * WHY mount to #app? The index.html file has a <div id="app"></div>.
 * Vite injects this script, Svelte takes over that div, and renders
 * the entire app inside it.
 */
import './app.css'; // Must be imported FIRST so Tailwind styles are available
import App from './App.svelte';
import { mount } from 'svelte';

// Svelte 5 uses `mount()` instead of `new App()` from Svelte 4
const app = mount(App, {
  target: document.getElementById('app')!,
});

export default app;
